import { render } from "./TarotDetailRelatedBoxList.vue?vue&type=template&id=66c53ae8&scoped=true"
import script from "./TarotDetailRelatedBoxList.vue?vue&type=script&lang=js"
export * from "./TarotDetailRelatedBoxList.vue?vue&type=script&lang=js"

import "./TarotDetailRelatedBoxList.vue?vue&type=style&index=0&id=66c53ae8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c53ae8"]])

export default __exports__